import { Repository } from "src/firebase/firestore/repository";
import { CoachRecording } from "./types/coach-recording.entity";

export class CoachRecordingRepository extends Repository<CoachRecording> {
  constructor() {
    super("coach_recordings");
  }
}

export const coachRecordingRepository = new CoachRecordingRepository();
